import z from 'zod';

const phoneRegex = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/);

export const newsletterSchema = z.object({
    email: z.string().email('invalidEmail'),
});

export const contactSchema = z.object({
    name: z.string().min(2, 'nameMustBeLonger'),
    email: z.string().email('invalidEmail'),
    phone: z.string().regex(phoneRegex, 'invalidPhoneNumber').optional(),
    comment: z.string().min(2, 'commentMustBeLonger'),
    files: z.array(z.any()).optional(),
    consent: z.literal(true, {
        errorMap: () => ({
            message: 'youMustAccept',
        }),
    }),
});

export const returnsSchema = z.object({
    name: z.string().min(2, 'nameMustBeLonger'),
    email: z.string().email('invalidEmail'),
    phone: z.string().regex(phoneRegex, 'invalidPhoneNumber').optional(),
    orderId: z.string().min(1, 'orderIdIsRequired'),
    orderDate: z.date().optional(),
    productName: z.string().min(2, 'productNameMustBeLonger'),
    productCode: z.string().min(1, 'productCodeIsRequired'),
    quantity: z.string().min(1).optional(),
    reasonForReturn: z.string(),
    productOpened: z.string(),
    comment: z.string().optional(),
    consent: z.literal(true, {
        errorMap: () => ({
            message: 'youMustAccept',
        }),
    }),
});

export type Contact = z.infer<typeof contactSchema>;
export type Newsletter = z.infer<typeof newsletterSchema>;
export type Returns = z.infer<typeof returnsSchema>;
